document.addEventListener( 'DOMContentLoaded', () => {
    // Get the first element with the class '.wpcf7-submit'
    const wpcf7Submit = document.querySelector('.wpcf7-submit');

    if (wpcf7Submit) {
        const parentParagraph = wpcf7Submit.closest('p');
        parentParagraph.classList.add('wpcf7-submit-wrapper');
    }

    function form_submit(event) {
        if (6 === event.detail.contactFormId) {
            document.getElementById('contact-section').classList.add('form-submit');
        }
    }

    document.addEventListener('wpcf7mailsent', function(event) {
        form_submit(event);
    }, false);

    document.addEventListener('wpcf7invalid', function(event) {
        form_submit(event);
    }, false);

    document.addEventListener('wpcf7mailfailed', function(event) {
        form_submit(event);
    }, false);
} );

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('select').forEach((select) => {
    new TomSelect(select, {
      create: false,
      searchField: ['text'],
      placeholder: '',
      allowEmptyOption: true,
      closeAfterSelect: true,
      hideSelected: false,
    });
  });});

